// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const DocumentIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="DocumentIcon" ref={forwardedRef} {...props}>
      <path d="M5 2h7.07L16 5.555V17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1m9.5 5.5h-4.25v-4H5.5v13h9zM14.257 6 11.75 3.733V6z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const DocumentIcon = /* @__PURE__ */ Object.assign(
  DocumentIconComponent,
  { displayName: 'DocumentIcon' },
);
